// Bundle Products Swiper Module
// Extracted from theme.js for modular loading

(function () {
    // Function to remove opacity after initialization
    function removeOpacity(element) {
        if (element) {
            element.style.opacity = '1';
            element.style.transition = 'opacity 0.3s ease-in';
        }
    }

    function initProductBundle(bundleSlider) {
        if (!bundleSlider) {
            bundleSlider = document.querySelector('[data-bundle-slider]');
        }
        if (!bundleSlider) return;

        // Verify it's a valid DOM element
        if (!(bundleSlider instanceof Element)) return;

        // Check if Slick is already initialized (avoid conflict)
        if (bundleSlider.classList.contains('slick-initialized')) {
            // console.log('Bundle slider already using Slick, skipping Swiper initialization');
            return;
        }

        const dots = bundleSlider.dataset.dots === 'true';
        const arrows = bundleSlider.dataset.arrows === 'true';

        // Check if already initialized
        if (bundleSlider.classList.contains('swiper-initialized')) return;

        const swiper = new Swiper(bundleSlider, {
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 15,
            loop: false,
            navigation: arrows ? {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            } : false,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"></span>';
                }
            },
            breakpoints: {
                1200: {
                    slidesPerView: 4,
                    slidesPerGroup: 1
                },
                768: {
                    slidesPerView: 3,
                    slidesPerGroup: 1
                },
                551: {
                    slidesPerView: 2,
                    slidesPerGroup: 1
                }
            },
            on: {
                init: function () {
                    removeOpacity(bundleSlider);
                }
            }
        });

        return swiper;
    }

    // Initialize with Intersection Observer
    function initProductBundlesWithObserver() {
        const bundleSliders = document.querySelectorAll('[data-bundle-slider]');
        if (!bundleSliders.length) return;

        // Apply opacity 0 initially
        bundleSliders.forEach(slider => {
            if (!slider.classList.contains('swiper-initialized')) {
                slider.style.opacity = '0';
            }
        });

        // Create Intersection Observer
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    initProductBundle(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '100px' // Start loading 100px before visible
        });

        // Observe all bundle sliders
        bundleSliders.forEach(slider => {
            observer.observe(slider);
        });
    }

    // Initialize on DOM ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProductBundlesWithObserver);
    } else {
        initProductBundlesWithObserver();
    }
})();

